// extracted by mini-css-extract-plugin
export default {"ctaBtn":"Button_ctaBtn__+iGM6","ctaInverBtn":"Button_ctaInverBtn__WTHrK"};